import gql from "graphql-tag";

export const productActivationSettingFragment = gql`
  fragment ProductActivationSettingFragment on ProductActivationSetting {
    id
    activationPcTitle
    activationPcContent
    activationPcSuccessedTitle
    activationPcSuccessedContent
    activationMbTitle
    activationMbContent
    activationMbSuccessedTitle
    activationMbSuccessedContent
    serialNumberPcContent
    serialNumberMbContent
    registerCouponPcBg
    completeCouponPcBg
    activationCouponPcBg
    registerCouponMbBg
    completeCouponMbBg
    activationCouponMbBg
    registerCoupon {
      name
      discountValueType
      discountValue
      minSpent {
        amount
        currency
      }
      code
    }
    completeCoupon {
      name
      discountValueType
      discountValue
      minSpent {
        amount
        currency
      }
      code
    }
    activationCoupon {
      name
      discountValueType
      discountValue
      minSpent {
        amount
        currency
      }
      code
    }
  }
`;
